import donkey from "../images/Logo_for_Header.png";
import comp from "../images/comp.png";
import friend from "../images/Friendship-2.jpg";
import kofi from "../images/Kofi.jpg";
import zaman from "../images/Zaman.jpeg";
import ByeBye from "../images/ByeBye.jpg";


const arrayImages = [
  <img className="h-[200px] w-[200px]" src={donkey} alt="donkey" />,
  <img className="h-[200px] w-[200px]" src={comp} alt="comp" />,
  <img className="h-[200px] w-[200px]" src={friend} alt="friend" />,
  <img className="h-[200px] w-[200px]" src={kofi} alt="kofi" />,
  <img className="h-[200px] w-[200px]" src={zaman} alt="zaman" />,
  <img className="h-[200px] w-[200px]" src={ByeBye} alt="byebye" />
 
];
export default arrayImages;
